import React from 'react'

export default function DefaultCloseForm({ ticket, onSubmit, submitting }) {
  return (
    <div className="ctf-section">
      <p className="ctf-no-form">No form configured for this team.</p>
    </div>
  )
}
